import { 
  ACTIVATE_LAYER_OBSTACLES, 
  SET_OBSTACLES_LIST, 
  DEACTIVATE_LAYER_OBSTACLES 
} from '../actions/obstacleActions';


const initial_state =  {
  showLayer: true,
  obstaclesFeatures: undefined,
};

export const obstacleReducer = (state = initial_state, action) => {
  switch (action.type) {
    case ACTIVATE_LAYER_OBSTACLES:
      return {
        ...state,
        showLayer: true
      };
    case DEACTIVATE_LAYER_OBSTACLES:
      return {
        ...state,
        showLayer: false
      };
    case SET_OBSTACLES_LIST:
      return {
        ...state,
        obstaclesFeatures: action.payload
      }; 
    default:
      return {...state};
  }
};